import React from 'react';
import { Button } from './ui/Button';
interface InlineCTAProps {
  text: string;
}
export function InlineCTA({
  text
}: InlineCTAProps) {
  const scrollToOffer = () => {
    const el = document.getElementById('offer-cta');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <div className="py-4 md:py-8 flex justify-center px-5" data-id="element-38">
      <Button onClick={scrollToOffer} className="w-full md:w-auto text-lg px-8 py-4 min-h-[48px]" data-id="element-39">
        {text}
      </Button>
    </div>;
}